module.exports =
  # Generic verbs
  'UPDATE': 'Update'
  'SAVE': 'Save'
  'EDIT': 'Edit'
  'SEND': 'Send'
  'CLOSE': 'Close'
  'CANCEL': 'Cancel'
  'UNSUBSCRIBE': 'Unsubscribe'
  'PROCESSING': 'Processing...'
  'SHOW_MORE': 'More'
  'CONFIRMATION_MSG': 'Are you sure?'
  'OK': 'OK'

  # Generic golf terms
  'SCORE': 'Score'
  'PUTTS': 'Putts'

  # Generic words
  'YEAR': 'Year'
  'MONTH': 'Month'
  'DAY': 'Day'

  # Validation
  'VALIDATION':
    'REQUIRED': 'This field is required.'
    'MATCH': 'Confirmation does not match.'
    'EMAIL': 'This email address is invalid.'
    'MIN_LENGTH': "This field must at least {{ n }} characters and contain at least three of uppercase, lowercase, numbers, symbols."
    'MAX_LENGTH': "This field must be shorter than {{ n }} chars."
    'DATE': "Input valid date."
    'NUMERIC': "This field must be numeric."
    'MIN_VALUE': "This field must be greater than {{ n }}."
    'MAX_VALUE': "This field must be less than {{ n }}."
    'STRENGTH': "This field must at least 10 characters and contain at least three of uppercase, lowercase, numbers, symbols."

  # Generic API Messages
  'API_SUCCESS': 'Your change was successfully saved'
  'API_ERROR': 'Failed to save your changes. Please check inputs and try again.'
  'EMAIL_DUPLICATED': 'This email address has already taken by another user. Please try another one.'
  'NAME_DUPLICATED': 'This name is already registered. Please input another name.'
  'CURRENT_PASSWORD_ERROR': 'The password you entered is wrong.'

  # Common
  'NO_ROUND':
    'LETS_CREATE': "Let's create your first scorecard!"
    'CREATE_NOW': 'Create it now.'

  'AGENCY_DENINED': "Agency request is in progress. So, you can't edit this scorecard."



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/core/translation/common.en.coffee